import React, { useState } from 'react';
import { Box, Collapse, Typography, IconButton, Divider, List, ListItem } from '@mui/material';
import { ChevronRight, ChevronLeft } from '@mui/icons-material';

const Drawer = ({ scrollToSection, sections }) => {
  const [open, setOpen] = useState(true);

  const handleToggle = () => {
    setOpen(!open);
  };

  return (
    <Box display="flex" alignItems="flex-start" sx={{
      marginTop: '1px'
    }}>
      <Divider />
      <Collapse in={open} orientation="horizontal" sx={{
        height: '100%',

      }}>
        <Box
          sx={{
            width: 200,
            backgroundColor: 'white',
            padding: 2,
            height: '100%',

          }}
        >
          {/* <Typography>Here are the details!</Typography> */}
          <List sx={{ position: 'sticky', top: 0 }}>
            <ListItem
              onClick={() => scrollToSection(sections.detailsRef)}
              sx={{ cursor: 'pointer' }}
            >
              <Typography
                sx={{
                  '&:hover': {
                    textDecoration: 'underline',
                  },
                }}
              >
                Details
              </Typography>
            </ListItem>
            <ListItem
              onClick={() => scrollToSection(sections.notesRef)}
              sx={{ cursor: 'pointer' }}
            >
              <Typography
                sx={{
                  '&:hover': {
                    textDecoration: 'underline',
                  },
                }}
              >
                Notes
              </Typography>
            </ListItem>
            <ListItem
              onClick={() => scrollToSection(sections.attachmentsRef)}
              sx={{ cursor: 'pointer' }}
            >
              <Typography
                sx={{
                  '&:hover': {
                    textDecoration: 'underline',
                  },
                }}
              >
                Attachments
              </Typography>
            </ListItem>
            <ListItem
              onClick={() => scrollToSection(sections.leadsRef)}
              sx={{ cursor: 'pointer' }}
            >
              <Typography
                sx={{
                  '&:hover': {
                    textDecoration: 'underline',
                  },
                }}
              >
                Leads
              </Typography>
            </ListItem>
            <ListItem
              onClick={() => scrollToSection(sections.contactsRef)}
              sx={{ cursor: 'pointer' }}
            >
              <Typography
                sx={{
                  '&:hover': {
                    textDecoration: 'underline',
                  },
                }}
              >
                Contacts
              </Typography>
            </ListItem>
            <ListItem
              onClick={() => scrollToSection(sections.dealsRef)}
              sx={{ cursor: 'pointer' }}
            >
              <Typography
                sx={{
                  '&:hover': {
                    textDecoration: 'underline',
                  },
                }}
              >
                Deals
              </Typography>
            </ListItem>
          </List>


        </Box>
      </Collapse>
      <IconButton onClick={handleToggle} sx={{ position: 'sticky', top: 0 }}>
        {open ? <ChevronLeft /> : <ChevronRight />}
      </IconButton>
    </Box>
  );
};

export default Drawer;
